/** Single source of truth for every internal route path in the app. */

export const ADMIN_SEGMENTS = {
  USERS: "users",
  CONTENT: "content",
  APPOINTMENTS: "appointments",
  REPORTS: "reports",
  PREGNANCY_WEEKS: "pregnancy-weeks",
  BRANDING: "branding",
  SUBSCRIPTION: "subscription",
  PAYMENTS: "payments",
  BABY_NAMES: "baby-names",
  BABY_NAME_ATTRIBUTES: "baby-name-attributes",
  STORE: "store"
};

export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  DASHBOARD: "/dashboard",
  HEALTH: "/health",
  PREGNANCY: "/pregnancy",
  PERIOD: "/period",
  BABY: "/baby",
  APPOINTMENTS: "/appointments",
  REPORTS: "/reports",
  ARTICLES: "/articles",
  ARTICLE_DETAIL: (id) => `/articles/${id}`,
  WELLNESS: "/wellness",
  TOOLS: "/tools",
  BABY_NAMES: "/baby-names",
  STORE: "/store",
  HEALTH_DETAIL: (domain) => `/health/${domain}`,
  PROFILE: "/profile",
  SUBSCRIPTION: "/subscription",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS: "/terms",
  ACCOUNT_DELETION: "/account-deletion",
  ADMIN: "/admin",
  ADMIN_USERS: `/admin/${ADMIN_SEGMENTS.USERS}`,
  ADMIN_CONTENT: `/admin/${ADMIN_SEGMENTS.CONTENT}`,
  ADMIN_APPOINTMENTS: `/admin/${ADMIN_SEGMENTS.APPOINTMENTS}`,
  ADMIN_REPORTS: `/admin/${ADMIN_SEGMENTS.REPORTS}`,
  ADMIN_PREGNANCY_WEEKS: `/admin/${ADMIN_SEGMENTS.PREGNANCY_WEEKS}`,
  ADMIN_BRANDING: `/admin/${ADMIN_SEGMENTS.BRANDING}`,
  ADMIN_SUBSCRIPTION: `/admin/${ADMIN_SEGMENTS.SUBSCRIPTION}`,
  ADMIN_PAYMENTS: `/admin/${ADMIN_SEGMENTS.PAYMENTS}`,
  ADMIN_BABY_NAMES: `/admin/${ADMIN_SEGMENTS.BABY_NAMES}`,
  ADMIN_BABY_NAME_ATTRIBUTES: `/admin/${ADMIN_SEGMENTS.BABY_NAME_ATTRIBUTES}`,
  ADMIN_STORE: `/admin/${ADMIN_SEGMENTS.STORE}`
};

/** Paths rendered with no auth-guarded chrome (see components/Layout.js). */
export const PUBLIC_PATHS = [
  ROUTES.HOME,
  ROUTES.LOGIN,
  ROUTES.REGISTER,
  ROUTES.PRIVACY_POLICY,
  ROUTES.TERMS,
  ROUTES.ACCOUNT_DELETION
];
